import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { setPageMeta } from '../lib/seo';

const Login: React.FC = () => {
  const { login, user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    setPageMeta({
      title: 'Sign In | Clouniq',
      description: 'Sign in to your clouniq account to manage cloud resources and orders.',
    });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await login(formData.email, formData.password);
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || error.message || 'An error occurred';
      notification.error({ message: 'Login failed', description: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container auth-container-wide">
        <div className="auth-card glass auth-shell">
          <aside className="auth-aside">
            <span className="section-tag">Workspace Access</span>
            <h2 className="auth-title">Welcome back</h2>
            <p className="auth-subtitle">Log in to manage sessions, billing, and machine access in one place.</p>
            <ul className="auth-points">
              <li>Live session status</li>
              <li>Plan and payment history</li>
              <li>Fast support escalation</li>
            </ul>
          </aside>

          <form onSubmit={handleSubmit} className="auth-form auth-form-panel">
            <h3>Sign in</h3>
            <p className="auth-form-copy">Use your workspace credentials to continue.</p>

            <div className="auth-field">
              <label className="auth-label" htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                placeholder="Work email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label" htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="auth-btn primary" disabled={isLoading}>
              {isLoading ? 'Please wait...' : 'Sign in'}
            </button>

            <p className="auth-switch">
              No account yet? <Link to="/register">Create one</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;



